import { ConfusedBrainIcon, OffensiveIcon, RefreshIcon, ThumbsDownIcon, ThumbsUpIcon } from "@components/library/Icons";
import { CursorClickIcon } from "@heroicons/react/outline";
import { CategoricalFeedbackLabel, LabelSentiment } from "@/services/feedback.service";

export enum DefaultFeedbackType {
  Correction = "correction",
  Rating = "rating",
  Action = "action",
  Issue = "issue",
  Comment = "comment",
}
// As list
export const DEFAULT_FEEDBACK_TYPES = [
  DefaultFeedbackType.Correction,
  DefaultFeedbackType.Rating,
  DefaultFeedbackType.Action,
  DefaultFeedbackType.Issue,
  DefaultFeedbackType.Comment,
];

export const SUGGESTED_LABELS: Partial<
  Record<
    DefaultFeedbackType,
    (CategoricalFeedbackLabel & {
      Icon: (props: React.ComponentProps<"svg">) => JSX.Element;
      keyboardShortcut?: string | undefined;
    })[]
  >
> = {
  [DefaultFeedbackType.Rating]: [
    { value: "good", sentiment: LabelSentiment.positive, Icon: ThumbsUpIcon, keyboardShortcut: "g" },
    { value: "bad", sentiment: LabelSentiment.negative, Icon: ThumbsDownIcon, keyboardShortcut: "b" },
  ],
  [DefaultFeedbackType.Action]: [
    { value: "selected", sentiment: LabelSentiment.positive, Icon: CursorClickIcon },
    { value: "saved", sentiment: LabelSentiment.positive, Icon: CursorClickIcon },
    { value: "deleted", sentiment: LabelSentiment.negative, Icon: CursorClickIcon },
    { value: "shared", sentiment: LabelSentiment.positive, Icon: CursorClickIcon },
    { value: "copied", sentiment: LabelSentiment.positive, Icon: CursorClickIcon },
  ],
  [DefaultFeedbackType.Issue]: [
    { value: "hallucination", sentiment: LabelSentiment.negative, Icon: ConfusedBrainIcon },
    { value: "repetition", sentiment: LabelSentiment.negative, Icon: RefreshIcon },
    { value: "inappropriate", sentiment: LabelSentiment.negative, Icon: OffensiveIcon },
  ],
};
